<template>
  <div class="corpdetail-container">
    <top-nav :shrinked="true"/>
    <div class="content">
      <div class="display-row">
        <div class="date-content-detail">
          <div>
            <span>12</span>
            <span>2020.10</span>
          </div>
        </div>
        <div class="corpdetail-right">
          <div class="detail-title">
            <span>{{dataInfo.title}}</span>
          </div>
          <div class="detail-look-container">
            <div class="detail-look">
              <span>浏览：{{dataInfo.hitNum}}</span>
            </div>
            <div class="detail-look-scale">
              <span :class="{'active':scaleIndex===1}" @click="scaleClick(1)">小</span>
              <span :class="{'active':scaleIndex===2}" @click="scaleClick(2)">中</span>
              <span :class="{'active':scaleIndex===3}" @click="scaleClick(3)">大</span>
            </div>
          </div>
        </div>
      </div>
      <div class="corpdetail-content">
        <div class="detail-line"></div>
        <div class="detail-content" :style="{'font-size':font+'px'}" v-html="dataInfo.content">
        </div>
      </div>
      <div class="detail-pre-next">
        <div class="ellipsis" :class="{'not-content':notPre}" @click="lastClick">上一条：{{dataInfo.lastTitle}}</div>
        <div class="ellipsis" :class="{'not-content':notNext}" @click="nextClick">下一条：{{dataInfo.nextTitle}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import topNav from '@/components/base/top-nav'
  import {fetchDetail} from '@/api/corporate.js';
  import {formatTime} from '@/utils';
  import $ from 'jquery';
  export default {
    name: "corpdetail",
    components:{
      topNav
    },
    data() {
      return {
        id:'',
        type:'',
        dataInfo: {},
        scaleIndex: 2,
        font: 14,
        notPre:false,
        notNext:false,
      }
    },
    mounted() {
      this.id = this.$route.query.id
      this.type = this.$route.query.type
      this.fetchData()
    },
    methods: {
      scaleClick(index){
        this.scaleIndex = index
        this.font = 14
        switch (index) {
            case 1:
              this.font = 12
              break;
            case 2:
              this.font = 14
              break;
            case 3:
              this.font = 20
              break;
        }
        $('.detail-content p').css('font-size',this.font+'px')
      },
      fetchData(){
        this.notPre = false
        this.notNext = false
        fetchDetail({id:this.id,type:this.type}).then(res=>{
          if(res.data && res.data.obj){
            this.$nextTick(() => {
              // 假设你想要在组件挂载后更改标题
              let title = res.data.obj.title
              // if(title != '嘉宏集团'){
              //   title = title + '_嘉宏集团'
              // }
              document.title = title
            })
            this.dataInfo = Object.assign(res.data,res.data.obj)
            this.dataInfo.createTime = formatTime(this.dataInfo.createTime,'yyyy-MM-dd')
            if(null==this.dataInfo.nextId){
              this.notNext = true
            }
            if(null==this.dataInfo.lastId){
              this.notPre = true
            }
          }
        })
      },
      lastClick(){
        if(this.dataInfo.lastId){
          this.id = this.dataInfo.lastId
          this.fetchData()
        }
      },
      nextClick(){
        if(this.dataInfo.nextId){
          this.id = this.dataInfo.nextId
          this.fetchData()
        }
      }
    }
  }
</script>

<style>
  @import "../../styles/corpdetail.css";
</style>
